import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
  }

  &.full-width {
    width: 100%;
  }
`;

export const ContentWrapper = styled.div`
  text-align: ${({ textAlignment }) => textAlignment || 'left'};
`;

export const Heading = styled.h2`
  font-size: 1.5rem;
  line-height: 1.38;
  margin: auto;
  margin-bottom: 2.5rem;
  width: 80%;

  color: ${themeGet('color.main-text', '#2B2C32')};
  &.velvet,
  &.pc-red {
    color: ${themeGet('color.white', '#FFFFFF')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 3.175rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 2.25rem;
    line-height: 3.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-bottom: 5rem;
  }
`;
